"use strict";

exports.__esModule = true;
exports.default = void 0;
var matchOperators = /[|\\{}()[\]^$+*?.]/g;

var escapeStringRegExp = function escapeStringRegExp(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }

  return str.replace(matchOperators, '\\$&');
};

var createFilter = function createFilter(inputValue, getOptionLabel) {
  return function (option) {
    return new RegExp(escapeStringRegExp(inputValue), 'gi').test(getOptionLabel(option));
  };
};

var _default = createFilter;
exports.default = _default;